import React from "react"

import { SelectedExpensesProvider, SelectedInboxInvoicesProvider } from "Shared/context/selectedExpenses.context"

import { DashboardContainer } from "./dashboard.container"

export const Dashboard = () => (
    <SelectedExpensesProvider>
        <SelectedInboxInvoicesProvider>
            <DashboardContainer />
        </SelectedInboxInvoicesProvider>
    </SelectedExpensesProvider>
)
